"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAvailableSortsGroup = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
function newMeasureSortSuggestion(identifier, attributeLocators) {
    if (attributeLocators === void 0) { attributeLocators = []; }
    var locators = sdk_model_1.newMeasureSort(identifier, "asc", attributeLocators).measureSortItem.locators;
    return {
        type: "measureSort",
        locators: locators,
    };
}
/**
 * @internal
 */
exports.newAvailableSortsGroup = function (attributeId, measureIds, normalSortEnabled, areaSortEnabled, explanation) {
    if (measureIds === void 0) { measureIds = []; }
    if (normalSortEnabled === void 0) { normalSortEnabled = true; }
    if (areaSortEnabled === void 0) { areaSortEnabled = true; }
    var metricSortsProp = measureIds.length
        ? {
            metricSorts: tslib_1.__spreadArrays(measureIds.map(function (localIdentifier) { return newMeasureSortSuggestion(localIdentifier); })),
        }
        : {};
    var explanationProp = explanation
        ? {
            explanation: explanation,
        }
        : {};
    return tslib_1.__assign(tslib_1.__assign({ itemId: sdk_model_1.localIdRef(attributeId), attributeSort: {
            normalSortEnabled: normalSortEnabled,
            areaSortEnabled: areaSortEnabled,
        } }, metricSortsProp), explanationProp);
};
//# sourceMappingURL=SortConfig.js.map